<template>
  <div class="add-form pure-form">
    <div class="f-input">
      <input
        type="text"
        v-model="keyName"
        v-if="needName"
        class="f-input-m"
        placeholder="key/name">
      <input type="checkbox" :checked="required" /> 必填项
      <select v-model="formatSelected" class="f-input-m">
        <option
          v-for="(item, index) in formats"
          :value="item"
          :key="index">
          {{item}}
        </option>
      </select>
      <span class="f-input-m">
        <b>:</b>
      </span>

      <template v-if="formatSelected !== 'array' && formatSelected !== 'object'">
        <input
          type="text"
          v-model="valName"
          class="f-input-m"
          placeholder="默认值"
          v-if="formatSelected === 'string'"
        >
        <input
          type="number"
          v-model="valName"
          class="f-input-m"
          placeholder="默认值"
          v-if="formatSelected === 'int'"
          @change="dealNumber"
        >
        <select
          name="value"
          v-model="valName"
          class="f-input-m"
          v-if="formatSelected === 'boolean'"
          @change="dealBoolean"
        >
          <option :value="true" selected>true</option>
          <option :value="false">false</option>
        </select>
        <input
          type="text"
          v-model="valName"
          class="f-input-m"
          v-if="formatSelected === 'unicode'"
          placeholder="默认值"
        />
        <input
          type="text"
          v-model="valName"
          class="f-input-m"
          v-if="formatSelected === 'datetime'"
          placeholder="默认值"
          onfocus="(this.type='date')"
          onblur="(this.type='text')"
        />
        <input
          type="text"
          v-model="desc"
          class="f-input-m"
          placeholder="描述"
        />
        <template v-if="formatSelected !== 'boolean'">
          <template v-if="formatSelected === 'datetime'">
            <input
              type="text"
              v-model="range[0]"
              class="f-input-m"
              v-if="formatSelected === 'datetime'"
              placeholder="范围"
              onfocus="(this.type='date')"
              onblur="(this.type='text')"
            /> -
            <input
              type="date"
              v-model="range[1]"
              class="f-input-m"
              v-if="formatSelected === 'datetime'"
              :min="range[0]"
            />
          </template>
          <template v-else>
            <input
              type="text"
              v-model="re"
              class="f-input-m"
              :placeholder="'正则' + reDefault[formatSelected]"
            />
          </template>
        </template>
      </template>
    </div>

    <div class="f-btns">
      <button
        class="pure-button f-confirm"
        @click="confirm">
        {{ this.formBtnText.confirmText }}
      </button>
      <button
        class="pure-button"
        @click="cancel">
        {{ this.formBtnText.cancelText }}
      </button>
    </div>
  </div>
</template>

<script>
import TemplateEdit from './TemplateEdit'
export default {
  name: 'item-add-form',
  components: {TemplateEdit},
  props: {
    needName: {
      default: true
    }
  },
  data () {
    return {
      formats: ['string', 'array', 'object', 'int', 'boolean', 'datetime', 'unicode'],
      formatSelected: 'string',
      // --
      keyName: '',
      valName: '',
      desc: '',
      re: '',
      range: ['', ''],
      reDefault: {
        int: '^[\\d]{1,10}$',
        string: '^[\\w\\W]{0,20}$',
        unicode: '^[\\w\\W]{0,20}$'
      },
      required: true
    }
  },
  inject: ['formBtnText'],
  watch: {
    range (val) {
      if (this.range[0] && this.range[1]) {
        if (this.range[0] > this.range[1]) {
          this.range[1] = ''
        }
      }
    }
  },
  methods: {
    confirm () {
      let val = null
      if (this.formatSelected === 'array' || this.formatSelected === 'object') {
        val = []
      } else {
        val = this.valName
      }
      let objData = {
        key: this.needName ? this.keyName : null,
        val: val,
        type: this.formatSelected,
        desc: this.desc,
        required: this.required
      }
      if (this.formatSelected !== 'array' && this.formatSelected !== 'object') {
        if (this.formatSelected === 'datetime') {
          objData['range'] = this.range
        } else {
          objData['re'] = this.re
        }
      }
      this.$emit('confirm', objData)
      this.keyName = ''
      this.valName = ''
      this.desc = ''
      this.re = ''
      this.range = ['', '']
      this.formatSelected = 'string'
    },
    cancel () {
      this.$emit('cancel')
    },
    dealBoolean () {
      this.valName = Boolean(this.valName)
    },
    dealNumber () {
      this.valName = Number(this.valName)
    }
  }
}
</script>

<style>
  .f-input, .f-btns {
    display: inline-block;
  }
  .f-btns {
    display: inline-block;
    margin-top: 0.5em;
  }
  .f-confirm {
    color: #fff !important;
    background: #05a5d1 !important;
  }
  .add-form {
    margin-bottom: 20px;
    font-size: 1em !important;
  }
  .pure-button {
    font-family: inherit;
    font-size: 100%;
    padding: 0.5em 1em;
    color: #444;
    color: rgba(0, 0, 0, 0.8);
    border: transparent;
    background-color: #E6E6E6;
    text-decoration: none;
    border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// ItemAddForm.vue?679e64b4